/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 뷰어 요소 통합 인덱스를 정의한다.
 *
 * @file /src/namespaces/components/Viewer.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 5. 19.
 */
import { Viewer as ViewerBase } from '@components/viewer/Viewer';
import { View as ViewBase } from '@components/viewer/View';
import { List as ListBase } from '@components/viewer/List';
import { Panel as PanelBase } from '@components/viewer/Panel';

export class Viewer extends ViewerBase {}
export namespace Viewer {
    export const View = ViewBase;
    export const List = ListBase;
    export const Panel = PanelBase;
}
